import { Box, Typography } from '@mui/material';

export function SmsPreview({ content, time = '16:30' }: { content: string; time?: string }) {
  return (
    <Box sx={{ pl: 1 }}>
      <Box
        sx={{
          position: 'relative',
          isolation: 'isolate',
          bgcolor: '#90caf978',
          borderRadius: '22px 22px 22px 4px',
          p: 2.5,
          mr: { xs: 1, sm: 4 },
        }}
      >
        <Typography
          sx={{
            whiteSpace: 'pre-wrap',
            overflowWrap: 'anywhere',
            lineHeight: 1.7,
          }}
        >
          {content}
        </Typography>

        <Typography
          variant="caption"
          color="text.secondary"
          display="block"
          textAlign="right"
          sx={{ mt: 1 }}
        >
          {time}
        </Typography>
      </Box>
    </Box>
  );
}
